<template>
  <iColumn gap="standard" width="fill">
    <iUploader :acceptable-file-types="acceptableFileTypes" @upload-file="captureFile">
      <iButton variant="secondary" width="fill" :is-loading="isUploading">
        + Choose a file to upload
      </iButton>
    </iUploader>

    <iText v-if="uploadError" variant="error" font-size="small">
      {{ uploadError }}
    </iText>

    <iColumn v-if="entries.length > 0" gap="extraSmall" width="fill">
      <iRow
        v-for="(entry, entryIndex) in entries"
        :key="entryIndex"
        gap="standard"
        vertical-align="middle"
        wrap="nowrap"
        width="fill"
      >
        <iColumn width="fill" gap="extraSmall">
          <iLink v-if="entry.url" :href="entry.url" target="_blank">
            {{ entry.name || "Uploaded file" }}
          </iLink>
          <iText v-else>
            {{ entry.name || "Uploaded file" }}
          </iText>
          <iText variant="subtle" font-size="small">
            {{ formatFileSize(entry.size) }}
          </iText>
        </iColumn>
        <iButton
          variant="tertiary"
          size="small"
          width="hug"
          @click="removeEntry(entryIndex)"
        >
          Remove
        </iButton>
      </iRow>
    </iColumn>
  </iColumn>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useQuestionnaireStore } from "@/stores/questionnaire-store";

export default {
  name: "QuestionnaireFileUpload",
  props: {
    sectionKey: {
      type: String,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isUploading: false,
      uploadError: "",
    };
  },
  computed: {
    ...mapState(useQuestionnaireStore, ["responseData"]),
    entries() {
      const list = this.responseData[this.sectionKey][this.field.key];
      return Array.isArray(list) ? list : [];
    },
    acceptableFileTypes() {
      return Array.isArray(this.field.acceptable_file_types) ? this.field.acceptable_file_types : [];
    },
  },
  methods: {
    ...mapActions(useQuestionnaireStore, [
      "uploadQuestionnaireAssetFile",
      "removeFileUploadEntry",
    ]),
    captureFile(file) {
      if (!file) {
        return;
      }
      this.isUploading = true;
      this.uploadError = "";
      this.uploadQuestionnaireAssetFile(
        this.sectionKey,
        this.field.key,
        file,
        () => {
          this.isUploading = false;
        },
        message => {
          this.isUploading = false;
          this.uploadError = message;
        },
      );
    },
    removeEntry(entryIndex) {
      this.removeFileUploadEntry(this.sectionKey, this.field.key, entryIndex);
    },
    formatFileSize(bytes) {
      if (!Number.isFinite(bytes) || bytes <= 0) {
        return "";
      }
      const units = ["B", "KB", "MB", "GB"];
      let index = 0;
      let size = bytes;
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024;
        index += 1;
      }
      return `${size.toFixed(size >= 10 || index === 0 ? 0 : 1)} ${units[index]}`;
    },
  },
};
</script>
